<style scoped>
.required-label::after {
  content: ' *';
  color: red;
}
.field-error-text {
  color: #ea5455;
  font-size: 0.857rem;
  margin-top: 0.25rem;
}
.is-invalid-select {
  border: 1px solid #ea5455;
  border-radius: 4px;
}
</style>

<template>
  <b-row class="match-height">
    <b-col lg="12">
      <b-card title="Add Old Asset">
        <b-form @submit.prevent="submitNewAsset">
          <b-row>

            <b-col cols="2">
              <b-button
                type="button"
                variant="primary"
                class="mr-1"
                @click="previous()"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  size="16"
                  class="align-middle"
                />
                Back
              </b-button>
              <br>
              <br>
              <br>
            </b-col>

            <b-col cols="12">

              <!-- Item — REQUIRED -->
              <b-form-group
                label-for="chosenItem"
              >
                <template #label>
                  <span class="required-label">Item</span>
                </template>
                <Select2
                  v-model="chosenItem"
                  :settings="settings"
                  @select="putItem($event)"
                />
                <div
                  v-if="frontendErrors.chosenItem || fieldError('asset_item_id')"
                  class="field-error-text"
                >
                  {{ frontendErrors.chosenItem || fieldError('asset_item_id') }}
                </div>
              </b-form-group>

              <!-- Ref ID — optional -->
              <b-form-group
                label="Ref ID"
                label-for="refId"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="refId"
                  placeholder="Ref ID"
                  :state="fieldState('asset_ref_id')"
                />
                <div
                  v-if="fieldError('asset_ref_id')"
                  class="field-error-text"
                >
                  {{ fieldError('asset_ref_id') }}
                </div>
              </b-form-group>

              <!-- Local ID — optional -->
              <b-form-group
                label="Local ID"
                label-for="localId"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="localId"
                  placeholder="Local ID"
                  :state="fieldState('asset_local_id')"
                />
                <div
                  v-if="fieldError('asset_local_id')"
                  class="field-error-text"
                >
                  {{ fieldError('asset_local_id') }}
                </div>
              </b-form-group>

              <!-- Group Asset — REQUIRED -->
              <b-form-group
                label-for="category"
                label-cols-md="12"
              >
                <template #label>
                  <span class="required-label">Group Asset</span>
                </template>
                <v-select-new
                  v-model="assetCategory"
                  :options="categories"
                  :class="{ 'is-invalid-select': frontendErrors.assetCategory || fieldError('asset_category') }"
                />
                <div
                  v-if="frontendErrors.assetCategory || fieldError('asset_category')"
                  class="field-error-text"
                >
                  {{ frontendErrors.assetCategory || fieldError('asset_category') }}
                </div>
              </b-form-group>

              <!-- Description — REQUIRED -->
              <b-form-group
                label-for="description"
                label-cols-md="12"
              >
                <template #label>
                  <span class="required-label">Description</span>
                </template>
                <b-form-input
                  v-model="assetDescription"
                  placeholder="Asset Description"
                  :state="frontendErrors.assetDescription || fieldError('asset_description') ? false : null"
                />
                <div
                  v-if="frontendErrors.assetDescription || fieldError('asset_description')"
                  class="field-error-text"
                >
                  {{ frontendErrors.assetDescription || fieldError('asset_description') }}
                </div>
              </b-form-group>

              <!-- Note — optional -->
              <b-form-group
                label="Note"
                label-for="note"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="assetNote"
                  placeholder="Asset Note"
                  :state="fieldState('asset_note')"
                />
                <div
                  v-if="fieldError('asset_note')"
                  class="field-error-text"
                >
                  {{ fieldError('asset_note') }}
                </div>
              </b-form-group>

              <!-- GPS — optional -->
              <b-form-group
                label="GPS"
                label-for="gps"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="assetGPS"
                  placeholder="Asset GPS"
                  :state="fieldState('asset_gps')"
                />
                <div
                  v-if="fieldError('asset_gps')"
                  class="field-error-text"
                >
                  {{ fieldError('asset_gps') }}
                </div>
              </b-form-group>

              <!-- Date of Acquisition — REQUIRED -->
              <b-form-group
                label-cols-md="12"
              >
                <template #label>
                  <span class="required-label">Date of Acquisition</span>
                </template>
                <b-form-datepicker
                  v-model="assetDateOfAcquisition"
                  placeholder="Asset Date of Acquisition"
                  :state="frontendErrors.assetDateOfAcquisition || fieldError('asset_date_of_acquistion') ? false : null"
                />
                <div
                  v-if="frontendErrors.assetDateOfAcquisition || fieldError('asset_date_of_acquistion')"
                  class="field-error-text"
                >
                  {{ frontendErrors.assetDateOfAcquisition || fieldError('asset_date_of_acquistion') }}
                </div>
              </b-form-group>

              <!-- Depreciation Method — REQUIRED -->
              <b-form-group
                label-for="assetDepreciationMethod"
                label-cols-md="12"
              >
                <template #label>
                  <span class="required-label">Depreciation Method</span>
                </template>
                <v-select-new
                  v-model="assetDepreciationMethod"
                  :options="methods"
                  :class="{ 'is-invalid-select': frontendErrors.assetDepreciationMethod || fieldError('asset_depreciation_method') }"
                />
                <div
                  v-if="frontendErrors.assetDepreciationMethod || fieldError('asset_depreciation_method')"
                  class="field-error-text"
                >
                  {{ frontendErrors.assetDepreciationMethod || fieldError('asset_depreciation_method') }}
                </div>
              </b-form-group>

                      <!-- Acquisition Value — REQUIRED -->
              <b-form-group
                label-for="assetAcquisitionValue"
                label-cols-md="12"
              >
                <template #label>
                  <span class="required-label">Acquisition Value</span>
                </template>
                <input
                  v-model="assetAcquisitionValue"
                  placeholder="Angka saja, contoh: 15000000"
                  inputmode="numeric"
                  class="form-control"
                  :class="{ 'is-invalid': frontendErrors.assetAcquisitionValue || fieldError('asset_acquistion_value') || numericWarnings.assetAcquisitionValue }"
                  @input="handleInput($event, 'assetAcquisitionValue')"
                >
                <div
                  v-if="numericWarnings.assetAcquisitionValue"
                  class="field-error-text"
                >
                  Hanya angka yang diperbolehkan. Huruf dan simbol diabaikan.
                </div>
                <div
                  v-else-if="frontendErrors.assetAcquisitionValue || fieldError('asset_acquistion_value')"
                  class="field-error-text"
                >
                  {{ frontendErrors.assetAcquisitionValue || fieldError('asset_acquistion_value') }}
                </div>
              </b-form-group>

              <!-- Residual Value — optional -->
              <b-form-group
                label="Residual Value"
                label-for="assetResidualValue"
                label-cols-md="12"
              >
                <input
                  v-model="assetResidualValue"
                  placeholder="Angka saja, contoh: 1000000"
                  inputmode="numeric"
                  class="form-control"
                  :class="{ 'is-invalid': fieldError('asset_residual_value') || numericWarnings.assetResidualValue }"
                  @input="handleInput($event, 'assetResidualValue')"
                >
                <div
                  v-if="numericWarnings.assetResidualValue"
                  class="field-error-text"
                >
                  Hanya angka yang diperbolehkan. Huruf dan simbol diabaikan.
                </div>
                <div
                  v-else-if="fieldError('asset_residual_value')"
                  class="field-error-text"
                >
                  {{ fieldError('asset_residual_value') }}
                </div>
              </b-form-group>

              <!-- Market Value — optional -->
              <b-form-group
                label="Market Value"
                label-for="assetMarketValue"
                label-cols-md="12"
              >
                <input
                  v-model="assetMarketValue"
                  placeholder="Angka saja, contoh: 12000000"
                  inputmode="numeric"
                  class="form-control"
                  :class="{ 'is-invalid': fieldError('asset_market_value') || numericWarnings.assetMarketValue }"
                  @input="handleInput($event, 'assetMarketValue')"
                >
                <div
                  v-if="numericWarnings.assetMarketValue"
                  class="field-error-text"
                >
                  Hanya angka yang diperbolehkan. Huruf dan simbol diabaikan.
                </div>
                <div
                  v-else-if="fieldError('asset_market_value')"
                  class="field-error-text"
                >
                  {{ fieldError('asset_market_value') }}
                </div>
              </b-form-group>

              <!-- Asset Condition — REQUIRED -->
              <b-form-group
                label-for="assetCondition"
                label-cols-md="12"
              >
                <template #label>
                  <span class="required-label">Asset Condition</span>
                </template>
                <v-select-new
                  v-model="assetCondition"
                  :options="conditions"
                  :class="{ 'is-invalid-select': frontendErrors.assetCondition || fieldError('asset_condition') }"
                />
                <div
                  v-if="frontendErrors.assetCondition || fieldError('asset_condition')"
                  class="field-error-text"
                >
                  {{ frontendErrors.assetCondition || fieldError('asset_condition') }}
                </div>
              </b-form-group>

              <!-- Asset Address — optional -->
              <b-form-group
                label="Asset Address"
                label-for="assetAddress"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="assetAddress"
                  placeholder="Asset Address"
                  :state="fieldState('asset_address')"
                />
                <div
                  v-if="fieldError('asset_address')"
                  class="field-error-text"
                >
                  {{ fieldError('asset_address') }}
                </div>
              </b-form-group>

              <!-- Asset Responsible — REQUIRED -->
              <b-form-group
                label-for="assetResponsible"
                label-cols-md="12"
              >
                <template #label>
                  <span class="required-label">Asset Responsible</span>
                </template>
                <b-form-input
                  v-model="assetResponsible"
                  placeholder="Asset Responsible"
                  :state="frontendErrors.assetResponsible || fieldError('asset_responsible') ? false : null"
                />
                <div
                  v-if="frontendErrors.assetResponsible || fieldError('asset_responsible')"
                  class="field-error-text"
                >
                  {{ frontendErrors.assetResponsible || fieldError('asset_responsible') }}
                </div>
              </b-form-group>

              <!-- Serial Number — optional -->
              <b-form-group
                label="Serial Number"
                label-for="assetSerialNumber"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="assetSerialNumber"
                  placeholder="Asset Serial Number"
                  :state="fieldState('asset_serial_number')"
                />
                <div
                  v-if="fieldError('asset_serial_number')"
                  class="field-error-text"
                >
                  {{ fieldError('asset_serial_number') }}
                </div>
              </b-form-group>

              <!-- Warranty — optional -->
              <b-form-group
                label="Warranty"
                label-for="assetWarranty"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="assetWarranty"
                  placeholder="Asset Warranty"
                  :state="fieldState('asset_warranty')"
                />
                <div
                  v-if="fieldError('asset_warranty')"
                  class="field-error-text"
                >
                  {{ fieldError('asset_warranty') }}
                </div>
              </b-form-group>

              <!-- Document — optional -->
              <b-form-group
                label="Document"
                label-for="assetDocument"
                label-cols-md="12"
              >
                <b-form-file
                  ref="uploadFile"
                  placeholder="Choose one or more files or drop it here..."
                  drop-placeholder="Drop files here..."
                  type="file"
                  @change="handleFilesUploadDocument"
                />
              </b-form-group>

              <!-- Photo — optional -->
              <b-form-group
                label="Photo"
                label-for="assetPhoto"
                label-cols-md="12"
              >
                <b-form-file
                  ref="uploadFilePhoto"
                  placeholder="Choose one file or drop it here."
                  drop-placeholder="Drop a file here..."
                  type="file"
                  :class="{ 'is-invalid': fieldError('photo') }"
                  @change="handleFilesUploadPhoto"
                />
                <div
                  v-if="fieldError('photo')"
                  class="field-error-text"
                >
                  {{ fieldError('photo') }}
                </div>
              </b-form-group>

            </b-col>
          </b-row>

          <!-- Backend field error summary -->
          <b-alert
            v-if="hasBackendErrors"
            variant="danger"
            show
            class="mb-1"
          >
            <div class="alert-body">
              <strong>Please fix the following errors:</strong>
              <ul class="mb-0 mt-50">
                <li
                  v-for="(err, key) in backendErrors"
                  :key="key"
                >
                  {{ err.message }}
                </li>
              </ul>
            </div>
          </b-alert>

          <b-button
            type="submit"
            variant="primary"
            :disabled="submitButtonDisabled"
          >
            {{ submitButtonDisabled ? 'Submitting...' : 'Submit' }}
          </b-button>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BListGroup,
  BListGroupItem,
  BFormDatepicker,
  BFormFile,
  BAlert,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import moment from 'moment-timezone'
import Ripple from 'vue-ripple-directive'
import Select2 from 'v-select2-component'
import apiEndpoints from '@/constants/apiEndpoints'

// Required fields — mirrors backend createAssets validation exactly:
// asset_item_id, asset_category, asset_description, asset_date_of_acquistion,
// asset_acquistion_value, asset_depreciation_method, asset_condition, asset_responsible
const REQUIRED_FIELDS = [
  { key: 'chosenItem', label: 'Item' },
  { key: 'assetCategory', label: 'Group Asset' },
  { key: 'assetDescription', label: 'Description' },
  { key: 'assetDateOfAcquisition', label: 'Date of Acquisition' },
  { key: 'assetDepreciationMethod', label: 'Depreciation Method' },
  { key: 'assetAcquisitionValue', label: 'Acquisition Value' },
  { key: 'assetCondition', label: 'Asset Condition' },
  { key: 'assetResponsible', label: 'Asset Responsible' },
]

export default {
  components: {
    BFormFile,
    BListGroup,
    BListGroupItem,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    Select2,
    BFormDatepicker,
    BAlert,
  },
  directives: {
    Ripple,
  },
  data() {
    const userToken = this.$cookies.get('userToken')
    return {
      photoFile: '',
      documentFile: '',
      refId: '',
      localId: '',
      assetCategory: '',
      assetDescription: '',
      assetGPS: '',
      assetDateOfAcquisition: '',
      assetAcquisitionValue: '',
      assetDepreciationMethod: 'Metode Garis Lurus',
      assetResidualValue: '',
      assetMarketValue: '',
      assetCondition: '',
      assetAddress: '',
      assetResponsible: '',
      assetSerialNumber: '',
      assetWarranty: '',
      assetNote: '',
      categories: ['Machinery (MC)', 'Furniture & Fixture', 'Office Equipment', 'Lab Equipment', 'Vehicle (VH)', 'Building', 'Software', 'Low Value Asset', 'Land', 'Field Equipment'],
      methods: ['None', 'Metode Garis Lurus', 'Metode Saldo Menurun', 'Metode Unit Produksi', 'Metode Jam Kerja', 'Metode Penyusutan Akselerasi'],
      conditions: ['Baik', 'Sedang', 'Buruk'],
      items: [],
      chosenItem: null,
      chosens: [],
      readonly: false,
      submitButtonDisabled: false,

      // Validation state
      frontendErrors: {},
      backendErrors: {},
      numericWarnings: {},

      settings: {
        ajax: {
          url: `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_ITEMS}`,
          beforeSend: xhr => {
            xhr.setRequestHeader('Authorization', `Bearer ${userToken}`)
          },
          data: params => ({
            search: params.term,
            offset: 0,
            limit: 50,
          }),
          processResults: response => {
            let resItems = response.data
            resItems = resItems.map(item => {
              item.text = `${item.item_code} - ${item.item_name}`
              item.id = item.item_id
              item.unitname = item.unit ? item.unit.unit_name : '-'
              return item
            })
            return { results: resItems }
          },
        },
      },
    }
  },
  computed: {
    hasBackendErrors() {
      return Object.keys(this.backendErrors).length > 0
    },
  },
  created() {
    window.setInterval(() => {
      this.removeReadOnly()
    }, 1000)
  },
  async mounted() {
    this.chosens = []
  },
  methods: {
    removeReadOnly() {
      const searches = document.getElementsByClassName('vs__search')
      for (let i = 0; i < searches.length; i += 1) {
        searches[i].removeAttribute('readonly')
      }
    },

    // Returns backend error message for a field key, or null
    fieldError(key) {
      return this.backendErrors[key] ? this.backendErrors[key].message : null
    },

    // Bootstrap :state for optional fields that can still get backend errors
    fieldState(key) {
      return this.backendErrors[key] ? false : null
    },

    // Frontend validation — checks all required fields before hitting the API
    validateForm() {
      const errors = {}
      REQUIRED_FIELDS.forEach(({ key, label }) => {
        const val = this[key]
        if (val === null || val === undefined || String(val).trim() === '') {
          errors[key] = `${label} is required.`
        }
      })
      this.frontendErrors = errors
      return Object.keys(errors).length === 0
    },

    submitNewAsset() {
      // Clear previous errors
      this.backendErrors = {}
      this.frontendErrors = {}
      this.numericWarnings = {}

      if (!this.validateForm()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Please fill in all required fields.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      this.submitButtonDisabled = true

      const formData = new FormData()
      formData.append('asset_item_id', this.chosenItem)
      formData.append('asset_ref_id', this.refId)
      formData.append('asset_local_id', this.localId)
      formData.append('asset_category', this.assetCategory)
      formData.append('asset_description', this.assetDescription)
      formData.append('asset_gps', this.assetGPS)
      formData.append('asset_date_of_acquistion', this.assetDateOfAcquisition)
      formData.append('asset_acquistion_value', this.assetAcquisitionValue)
      formData.append('asset_depreciation_method', this.assetDepreciationMethod)
      formData.append('asset_residual_value', this.assetResidualValue)
      formData.append('asset_market_value', this.assetMarketValue)
      formData.append('asset_condition', this.assetCondition)
      formData.append('asset_address', this.assetAddress)
      formData.append('asset_responsible', this.assetResponsible)
      formData.append('asset_serial_number', this.assetSerialNumber)
      formData.append('asset_note', this.assetNote)
      formData.append('asset_warranty', this.assetWarranty)
      formData.append('time', moment().toISOString())

      if (this.documentFile && typeof this.documentFile[0] !== 'undefined') {
        formData.append('document', this.documentFile[0], this.documentFile[0].name)
      }
      if (this.photoFile && typeof this.photoFile[0] !== 'undefined') {
        formData.append('photo', this.photoFile[0], this.photoFile[0].name)
      }

      const userToken = this.$cookies.get('userToken')
      const headers = { Authorization: `Bearer ${userToken}` }

      axios
        .post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_CREATE_ASSET}`,
          formData,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            // Reset form
            this.refId = ''
            this.assetCategory = ''
            this.assetDescription = ''
            this.assetGPS = ''
            this.assetDateOfAcquisition = ''
            this.assetAcquisitionValue = ''
            this.assetDepreciationMethod = 'Metode Garis Lurus'
            this.assetResidualValue = ''
            this.assetMarketValue = ''
            this.assetCondition = ''
            this.assetAddress = ''
            this.assetResponsible = ''
            this.assetSerialNumber = ''
            this.assetWarranty = ''
            this.assetNote = ''
            this.photoFile = ''
            this.documentFile = ''
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Create Asset Success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.replace({ name: 'apps-procurement-assets-list' })
          } else {
            this.submitButtonDisabled = false

            // Parse backend field-level errors
            const errorData = response.data.data
            if (errorData && typeof errorData === 'object') {
              this.backendErrors = errorData
            }

            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || 'Create Asset Failed',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(err => {
          this.submitButtonDisabled = false

          const res = err.response && err.response.data
          if (res && res.data && typeof res.data === 'object') {
            this.backendErrors = res.data
          }

          this.$toast({
            component: ToastificationContent,
            props: {
              title: (res && res.message) || 'Create Asset Failed',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    handleFilesUploadDocument(e) {
      this.documentFile = e.target.files || e.dataTransfer.files
    },

    handleFilesUploadPhoto(e) {
      this.photoFile = e.target.files || e.dataTransfer.files
    },

    putItem({ id }) {
      this.chosenItem = id
      // Clear frontend error once item is selected
      this.$delete(this.frontendErrors, 'chosenItem')
    },

    getOptionLabel(option) {
      return (option && option.label) || ''
    },

    getOptionKey(option) {
      return (option && option.value) || ''
    },

    inputSearch(search) {

    },

    removeRow(val) {
      this.chosens = this.chosens.filter(obj => obj.value !== val)
    },

    dateFormat(value, format = 'MM/DD/YYYY') {
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    },

    handleInput(event, field) {
      this.filterNumeric(field, event)
    },

    filterNumeric(field, event) {
      const raw = event.target.value || ''
      // Strip thousands separators (dots and commas) then remove any remaining non-digit chars
      const cleaned = raw.replace(/[.,]/g, '').replace(/[^0-9]/g, '')
      const hadInvalidChars = raw.replace(/[0-9.,]/g, '').length > 0
      this[field] = cleaned
      // Show warning if user typed letters or other invalid symbols
      if (hadInvalidChars) {
        this.$set(this.numericWarnings, field, true)
        // Auto-clear warning after 3 seconds
        setTimeout(() => { this.$delete(this.numericWarnings, field) }, 3000)
      } else {
        this.$delete(this.numericWarnings, field)
      }
      // Clear frontend required-field error once they start filling the field
      if (cleaned) this.$delete(this.frontendErrors, field)
    },

    previous() {
      this.$router.push({ name: 'apps-procurement-assets-list' })
    },

    capitalizeWords(str) {
      return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    },
  },
}
</script>
